import React, { useState, useEffect } from 'react';
import './style.css';
import { FaBars, FaTimes } from 'react-icons/fa';
import { Link, useNavigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import BotaoBusca from '../BotaoBusca.js';

function Header() {
  const [menuExpanded, setMenuExpanded] = useState(false);
  const [isEstudante, setIsEstudante] = useState(false);
  const navigate = useNavigate();

  const toggleMenu = () => {
    setMenuExpanded(prev => !prev);
  };

  useEffect(() => {
    console.log('Header foi renderizado');
  }, []);

  // Identifica se o usuário logado é estudante (nível 1). O JWT pode ter
  // `tipo === "estudante"` e/ou `acesso_autorizacao === 1`. Estudantes
  // só veem os links "Home" e "Sair" no header.
  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) {
      setIsEstudante(false);
      return;
    }
    try {
      const decoded = jwtDecode(token);
      const estudante =
        decoded?.tipo === 'estudante' ||
        Number(decoded?.acesso_autorizacao) === 1;
      setIsEstudante(Boolean(estudante));
    } catch {
      setIsEstudante(false);
    }
  }, []);

  const handleSair = () => {
    setMenuExpanded(false);
    try {
      localStorage.clear();
      sessionStorage.clear();
    } catch { /* ignore */ }
    navigate('/', { replace: true });
  };

  return (
    <header className="header">
      <input
        type="checkbox"
        id="check"
        checked={menuExpanded}
        onChange={toggleMenu}
      />
      <label htmlFor="check" className="nav-icons">
        {menuExpanded ? <FaTimes id="close-icon" /> : <FaBars id="menu-icon" />}
      </label>

      <nav className={`menu-h ${menuExpanded ? 'expandir' : ''}`} id="menu-h">
        <Link to="/dashboard" className="dropdown voltar" onClick={() => setMenuExpanded(false)}>Home</Link>
        {!isEstudante && (
          <>
            <Link to="/" className="dropdown estudante" onClick={() => setMenuExpanded(false)}>Histórico</Link>
            <Link to="/" className="dropdown unidade" onClick={() => setMenuExpanded(false)}>Acompanhamento</Link>
          </>
        )}
        <button
          type="button"
          className="dropdown header-sair-btn"
          onClick={handleSair}
          style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0, font: 'inherit', color: 'inherit' }}
        >
          Sair
        </button>
      </nav>
    </header>
  );
}

export default Header;
